import { Link } from "react-router-dom";

const OPTIONS = [
  { mode: "discovery", label: "Tonight's Discovery", to: "/featured/discovery" },
  { mode: "community", label: "Community's Choice", to: "/featured/community" },
];

export default function FeaturedCategoryToggle({ activeMode = "discovery" }) {
  return (
    <nav className="ft-category-toggle ft-reveal" aria-label="Featured category">
      <div className="ft-category-toggle-pill" role="tablist">
        {OPTIONS.map(({ mode, label, to }) => {
          const isActive = activeMode === mode;
          return (
            <Link
              key={mode}
              to={to}
              role="tab"
              aria-selected={isActive}
              className={[
                "ft-category-toggle-btn",
                isActive && "ft-category-toggle-btn--active",
                isActive && mode === "discovery" && "ft-category-toggle-btn--active-white",
                isActive && mode === "community" && "ft-category-toggle-btn--active-gold",
              ]
                .filter(Boolean)
                .join(" ")}
            >
              {label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
